import './nav.css';
import { Component, h, state, css, signal, Fragment } from 'pylevate-runtime';
import { currentTheme, toggleTheme, logout } from '../api.js';
import { Orb } from '../ui/orb.js';
export class Nav extends Component {
  get theme() { return this._theme.value; }
  set theme(v) { this._theme.value = v; }
  constructor(email = '', ws_state = '', ...kw) {
    super(...kw, {email: email, ws_state: ws_state});
    this._theme = signal('dark');
  }
  flip() {
    this.theme.value = toggleTheme();
  }
  signout() {
    logout();
  }
  componentDidMount() {
    this._theme.value = currentTheme();
  }
  get_context(props) {
    let ws = (props['ws_state'] ?? undefined) || '';
    props['ws_class'] = (ws === 'AWAKE' ? 'ws awake' : 'ws');
    props['ws_label'] = ({AWAKE: 'Awake', SLEEPING: 'Asleep', WAKING: 'Waking…'}[ws] ?? 'Workspace');
    props['orb_state'] = ({AWAKE: 'idle', SLEEPING: 'asleep', WAKING: 'waking'}[ws] ?? 'asleep');
    props['theme_icon'] = (this._theme.value === 'dark' ? '☾' : '☀');
    return props;
  }
  render(props, state, context) {
    let { email, ws_state, ...rest } = props || {};
    const _ctx = this.get_context({ email, ws_state, ...rest });
    ({ email, ws_state, ...rest } = _ctx);
    const { ws_class, ws_label, orb_state, theme_icon } = _ctx;
    const children = props && props.children;
    return h('div', {className: 'nav-6dd104'}, h(Fragment, null, h('a', {className: 'brand-6dd104', href: '/'}, h(Fragment, null, h('span', {className: 'dot-6dd104'}), h('span', null, 'uplevate'))), h('a', {className: "ws-6dd104" + (ws_class == 'ws awake' ? ' ' + "awake-6dd104" : ''), href: '/account', title: 'Your workspace'}, h(Fragment, null, h(Orb, {state: orb_state, size: 14}), h('span', null, `${ws_label}`))), h('span', {className: 'spacer-6dd104'}), h('a', {className: 'lnk-6dd104', href: '/'}, 'Chat'), h('a', {className: 'lnk-6dd104 lnk-hide-6dd104', href: '/account'}, 'Account'), h('a', {className: 'lnk-6dd104 lnk-hide-6dd104', href: '/keys'}, 'API keys'), h('span', {className: 'mail-6dd104'}, `${email}`), h('button', {className: 'btn-6dd104', onClick: this.flip.bind(this), title: 'Theme'}, `${theme_icon}`), h('button', {className: 'btn-6dd104', onClick: this.signout.bind(this)}, 'Sign out')));
  }
}
